'use strict';

import fireCustomEvent from './modules/fire-custom-event';
import showBrowserUpdateMessage from './modules/browser-update';

showBrowserUpdateMessage({ vs: { i: 10, f: -2, o: -2, s: 9, c: -5 }, api: 4 });

let externalLoadDelay = 500;
let externalLoadTimeout;

import 'glob:./../../components/**/*.js';

function initLoad() {

  fireCustomEvent('init-load');

}

function initContentLoad() {

  fireCustomEvent('init-content-load');

  window.setTimeout(initDelayedLoad, externalLoadDelay);

}

function initDelayedLoad() {

  fireCustomEvent('init-delayed-load');

  if (externalLoadTimeout) {
    window.clearTimeout(externalLoadTimeout);
  }

}

window.addEventListener('load', initLoad);
document.addEventListener('DOMContentLoaded', initContentLoad, false);



// WEBPACK FOOTER //
// ./website/assets/scripts/main.js